import { CellProps } from 'react-table'
import { TFunction } from '_metronic/i18n/Metronici18n'
import {
  ChipListCell,
  PlainHeader,
  sortableColumn,
  StackedCell,
  StatusBadge,
  TableColumn,
} from 'app/components'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { FornecedorList } from '../../../core/_models'
import { formataCnpj } from '../../../core/formularioFornecedor'
import { rotuloTipoFornecedor } from '../../../../dispositivos/core/rotulos'
import { FornecedoresActionsCell } from './FornecedoresActionsCell'

export const FornecedoresColumns = (t: TFunction): ReadonlyArray<TableColumn<FornecedorList>> => [
  sortableColumn<FornecedorList>({
    id: 'nome',
    useQueryRequest,
    fields: [{ field: 'nome', label: t('pagina.fornecedores.col.razao_social') }],
    Cell: ({ row }: CellProps<FornecedorList>) => (
      <StackedCell primary={row.original.nome} secondary={row.original.nomeFantasia ?? ''} />
    ),
  }),
  sortableColumn<FornecedorList>({
    id: 'cnpj',
    cellWidth: '180px',
    hideOnMobile: true,
    useQueryRequest,
    fields: [{ field: 'cnpj', label: t('pagina.fornecedores.col.cnpj') }],
    Cell: ({ row }: CellProps<FornecedorList>) => (
      <StackedCell tabular primary={formataCnpj(row.original.cnpj)} />
    ),
  }),
  {
    Header: () => <PlainHeader>{t('pagina.fornecedores.col.tipos')}</PlainHeader>,
    id: 'tipos',
    cellWidth: '240px',
    hideOnMobile: true,
    Cell: ({ row }: CellProps<FornecedorList>) => (
      <ChipListCell
        items={(row.original.tipos ?? []).map((tipo) => rotuloTipoFornecedor(t, tipo))}
        noun={{ singular: 'tipo', plural: 'tipos' }}
      />
    ),
  },
  {
    Header: () => <PlainHeader>{t('pagina.fornecedores.col.logo')}</PlainHeader>,
    id: 'logo',
    cellWidth: '120px',
    hideOnMobile: true,
    Cell: ({ row }: CellProps<FornecedorList>) => (
      <StackedCell
        primary={row.original.logoCadastrada ? t('pagina.fornecedores.logo_cadastrada') : ''}
      />
    ),
  },
  sortableColumn<FornecedorList>({
    id: 'ativo',
    cellWidth: '120px',
    useQueryRequest,
    fields: [{ field: 'ativo', label: t('cols.status') }],
    Cell: ({ row }: CellProps<FornecedorList>) => <StatusBadge active={row.original.ativo} />,
  }),
  {
    Header: () => <PlainHeader>{t('cols.actions')}</PlainHeader>,
    id: 'actions',
    cellWidth: '120px',
    align: 'end',
    Cell: ({ row }: CellProps<FornecedorList>) => (
      <FornecedoresActionsCell fornecedor={row.original} />
    ),
  },
]
